module.exports = __webpack_public_path__ + "static/media/gallery-9.df718658.jpg";